import { Navigate } from "react-router-dom";
import React from "react";
import Loading_Screen from "../common/Loading_Screen";
import PrivateRoute from "../auth/PrivateRoute";

const Loader = (Component) => {
  return (props) => (
    <React.Suspense fallback={<Loading_Screen loading={true} />}>
      <Component {...props} />
    </React.Suspense>
  );
};

const Login = Loader(React.lazy(() => import(`../auth/Login`)));
const Dashboard = Loader(
  React.lazy(() => import(`../component/Dashboard/Dashboard`))
);
const Home = Loader(
  React.lazy(() => import(`../pages/Landing Pages/Home/Home`))
);
const Dash_Landing = Loader(
  React.lazy(() => import(`../component/Dashboard/Dash_Landing`))
);
const Security_Privacy = Loader(
  React.lazy(
    () => import(`../pages/Dash Screen/Tool Data Screen/Security Privacy`)
  )
);
const Performance_Technical = Loader(
  React.lazy(
    () => import("../pages/Dash Screen/Tool Data Screen/Performance Technical")
  )
);
const Mobile_Responsiveness = Loader(
  React.lazy(
    () => import("../pages/Dash Screen/Tool Data Screen/Mobile Responsiveness")
  )
);
const Content_Information = Loader(
  React.lazy(
    () => import("../pages/Dash Screen/Tool Data Screen/Content Information")
  )
);
const Interactivity_Engagement = Loader(
  React.lazy(
    () =>
      import("../pages/Dash Screen/Tool Data Screen/Interactivity Engagement")
  )
);
const Branding_Visual = Loader(
  React.lazy(
    () =>
      import("../pages/Dash Screen/Tool Data Screen/Branding Visual Identity")
  )
);
const Navigation = Loader(
  React.lazy(() => import("../pages/Dash Screen/Tool Data Screen/Navigation"))
);
const Accessibility = Loader(
  React.lazy(
    () => import("../pages/Dash Screen/Tool Data Screen/Accessibility")
  )
);
const Integration_Service = Loader(
  React.lazy(
    () => import("../pages/Dash Screen/Tool Data Screen/Integration Services")
  )
);
const Report_File = Loader(
  React.lazy(() => import("../component/Report/Report History/Report_File"))
);
const Sitemap = Loader(
  React.lazy(() => import("../pages/Landing Pages/Sitemap"))
);
const About = Loader(React.lazy(() => import("../pages/Landing Pages/About")));
const Terms_and_Condtions = Loader(
  React.lazy(() => import("../pages/Landing Pages/Terms and Conditions"))
);
const Faq = Loader(React.lazy(() => import("../pages/Landing Pages/Faq")));
const ColourScreen = Loader(
  React.lazy(() => import("../pages/Dash Screen/DBIM Data Screen/Colours"))
);
const Iconography = Loader(
  React.lazy(() => import("../pages/Dash Screen/DBIM Data Screen/Iconography"))
);
const Typography = Loader(
  React.lazy(() => import("../pages/Dash Screen/DBIM Data Screen/Typography"))
);
const Logo_Lockup = Loader(
  React.lazy(() => import("../pages/Dash Screen/DBIM Data Screen/Logo Lockup"))
);
const Imagery = Loader(
  React.lazy(() => import("../pages/Dash Screen/DBIM Data Screen/Imagery"))
);
const ContentScreen = Loader(
  React.lazy(() => import("../pages/Dash Screen/DBIM Data Screen/Content"))
);
const Performance_Enhancement = Loader(
  React.lazy(
    () =>
      import("../pages/Dash Screen/DBIM Data Screen/Performance Enhancement")
  )
);
const Search_Functionality = Loader(
  React.lazy(
    () => import("../pages/Dash Screen/DBIM Data Screen/Search Functionality")
  )
);
const Header_and_Footer = Loader(
  React.lazy(
    () => import("../pages/Dash Screen/DBIM Data Screen/Header and Footer")
  )
);
const Landing_Layout = Loader(
  React.lazy(() => import("../pages/Landing Pages"))
);

export const routes = [
  {
    id: 1,
    path: "/",
    element: <Landing_Layout />,
    children: [{ path: "", element: <Home /> }],
  },
  {
    id: 2,
    path: "/login",
    element: <Landing_Layout />,
    children: [
      {
        path: "",
        element: <Login />,
      },
    ],
  },
  {
    id: 3,
    path: "/dashboard/dynamicsiteIdfromjainparichay",
    element: <Landing_Layout />,
    children: [{ path: "", element: <Home /> }],
  },
  {
    id: 4,
    path: "/websiteDashboard/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Dash_Landing reportType={`toolReport`} />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 5,
    path: "/colours/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <ColourScreen />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 6,
    path: "/iconography/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Iconography />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 7,
    path: "/typography/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Typography />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 8,
    path: "/logo_lockup/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Logo_Lockup />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 9,
    path: "/imagery/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Imagery />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 10,
    path: "/content/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <ContentScreen />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 11,
    path: "/performance_enhancement/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Performance_Enhancement />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 12,
    path: "/search_functionality/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Search_Functionality />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 13,
    path: "/security_privacy/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Security_Privacy />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 14,
    path: "/performance_technical/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Performance_Technical />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 15,
    path: "/integration_service/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Integration_Service />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 16,
    path: "/mobile_responsiveness/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Mobile_Responsiveness />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 17,
    path: "/content_information/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Content_Information />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 18,
    path: "/interactivity_engagement/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Interactivity_Engagement />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    id: 19,
    path: "/branding_visual/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Branding_Visual />
          </PrivateRoute>
        ),
      },
    ],
  },

  {
    id: 20,
    path: "/navigation/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Navigation />
          </PrivateRoute>
        ),
      },
    ],
  },

  {
    id: 21,
    path: "/accessibility/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Accessibility />
          </PrivateRoute>
        ),
      },
    ],
  },

  {
    id: 22,
    path: "/surveyReport/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Dash_Landing reportType={`survey`} />
          </PrivateRoute>
        ),
      },
    ],
  },

  {
    id: 23,
    path: "/reports/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Report_File />
          </PrivateRoute>
        ),
      },
    ],
  },

  {
    id: 25,
    path: "/dbims_report/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Dash_Landing reportType={`dbims_report`} />
          </PrivateRoute>
        ),
      },
    ],
  },

  {
    id: 25,
    path: "/sitemap",
    element: <Landing_Layout />,
    children: [{ path: "", element: <Sitemap /> }],
  },

  {
    id: 26,
    path: "/about",
    element: <Landing_Layout />,
    children: [{ path: "", element: <About /> }],
  },
  {
    id: 27,
    path: "/terms_condition",
    element: <Landing_Layout />,
    children: [{ path: "", element: <Terms_and_Condtions /> }],
  },
  {
    id: 29,
    path: "/faq",
    element: <Landing_Layout />,
    children: [{ path: "", element: <Faq /> }],
  },
  { id: 31, path: "*", element: <Navigate to="/" replace /> },
  {
    id: 12,
    path: "/headerAndFooter/:id",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Header_and_Footer />
          </PrivateRoute>
        ),
      },
    ],
  },
];
